import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from "./Components/NavbarSection/Navbar";
import HomePage from "./Components/HomepageSections/HomePage";
import EmergencyBlood from "./Components/EmergencyBloodSection/EmergencyBlood";
import Volunteer from "./Components/VolunteerSection/Volunteer";
import Login from "./Components/LoginSection/Login";
import HospitalLogin from "./Components/VolunteerSection/HospitalLogin";
import DonorRegistration from "./Components/LoginSection/DonorRegistration";
import Footer from "./Components/FooterSection/Footer";
import { Toaster } from 'react-hot-toast';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SearchRequests from "./Components/SearchRequests";
import VehicleRegistration from "./Components/VolunteerSection/VehicleRegistration";
import Register from './Components/LoginSection/Register';
import HospitalRegistration from './Components/VolunteerSection/HospitalRegistration';
import GallerySection from './Components/HomepageSections/GallerySection';
import DashboardLayout from './Components/Dashboard/DashboardLayout';
import DonorDashboard from './Components/Dashboard/DonorDashboardSections/DonorDashboard';
import RequesterDashboard from './Components/Dashboard/RequesterDashboardSection/RequesterDashboard';
import VerifyDonation from './Components/Dashboard/RequesterDashboardSection/VerifyDonation';
import { UserStatsDashboard } from './Components/Dashboard/UserStatistics';
import ForgotPassword from "./Components/LoginSection/ForgotPassword";
import ResetPassword from "./Components/LoginSection/ResetPassword";
import PrivateRoute from './Components/PrivateRoute';
import AdminRoute from './Components/ProtectedRoutes/AdminRoute';
import UserProfilePage from './Components/UserProfile/UserProfilePage';

// Import admin components from index.js
import { 
  AdminLogin, 
  AdminRegister,
  AdminDashboard,
  AdminDonors,
  AdminRequests,
  AdminHospitals,
  AdminVehicles,
  AdminSettings 
} from './Components/AdminPanel';
import AdminLayout from './Components/AdminPanel/AdminDashboardLayout/AdminLayout';

// Import admin subcomponents
import DonorList from './Components/AdminPanel/AdminDashboardLayout/AdminDonors/DonorList';
import DonorDetails from './Components/AdminPanel/AdminDashboardLayout/AdminDonors/DonorDetails';
import DonorForm from './Components/AdminPanel/AdminDashboardLayout/AdminDonors/DonorForm';
import RequestList from './Components/AdminPanel/AdminDashboardLayout/AdminRequests/RequestList';
import RequestDetails from './Components/AdminPanel/AdminDashboardLayout/AdminRequests/RequestDetails';
import RequestForm from './Components/AdminPanel/AdminDashboardLayout/AdminRequests/RequestForm';

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <Toaster position="top-right" />
        <ToastContainer position="top-right" autoClose={5000} />
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<><Navbar /><HomePage /><Footer /></>} />
          <Route path="/emergency-blood" element={<><Navbar /><EmergencyBlood /><Footer /></>} />
          <Route path="/volunteer" element={<><Navbar /><Volunteer /><Footer /></>} />
          <Route path="/login" element={<><Navbar /><Login /><Footer /></>} />
          <Route path="/hospital-login" element={<><Navbar /><HospitalLogin /><Footer /></>} />
          <Route path="/register" element={<><Navbar /><Register /><Footer /></>} />
          <Route path="/register-donor" element={<><Navbar /><DonorRegistration /><Footer /></>} />
          <Route path="/register-hospital" element={<><Navbar /><HospitalRegistration /><Footer /></>} />
          <Route path="/search-requests" element={<><Navbar /><SearchRequests /><Footer /></>} />
          <Route path="/register-vehicle" element={<><Navbar /><VehicleRegistration /><Footer /></>} />
          <Route path="/gallery" element={<><Navbar /><GallerySection /><Footer /></>} />
          <Route path="/forgot-password" element={<><Navbar /><ForgotPassword /><Footer /></>} />
          <Route path="/reset-password" element={<><Navbar /><ResetPassword /><Footer /></>} />

          {/* Admin Routes - Public */}
          <Route path="/admin/login" element={<><Navbar /><AdminLogin /><Footer /></>} />
          <Route path="/admin/register" element={<><Navbar /><AdminRegister /><Footer /></>} />
          
          {/* Admin Routes - Protected */}
          <Route path="/admin/dashboard" element={<AdminRoute><AdminLayout /></AdminRoute>}>
            <Route index element={<AdminDashboard />} />
            
            {/* Admin Donor Routes */}
            <Route path="donors" element={<AdminDonors />} />
            <Route path="donors/list" element={<DonorList />} />
            <Route path="donors/details/:id" element={<DonorDetails />} />
            <Route path="donors/form" element={<DonorForm />} />
            
            {/* Admin Request Routes */}
            <Route path="requests" element={<AdminRequests />} />
            <Route path="requests/list" element={<RequestList />} />
            <Route path="requests/details/:id" element={<RequestDetails />} />
            <Route path="requests/form" element={<RequestForm />} />
            
            {/* Other Admin Routes */}
            <Route path="hospitals" element={<AdminHospitals />} />
            <Route path="vehicles" element={<AdminVehicles />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="inventory" element={<div className="p-6"><h1 className="text-2xl font-bold">Blood Inventory Management</h1></div>} />
            <Route path="events" element={<div className="p-6"><h1 className="text-2xl font-bold">Events Management</h1></div>} />
            <Route path="users" element={<div className="p-6"><h1 className="text-2xl font-bold">Admin Users Management</h1></div>} />
          </Route>

          {/* Donor Dashboard Routes */}
          <Route path="/dashboard" element={<PrivateRoute><DashboardLayout><UserStatsDashboard /></DashboardLayout></PrivateRoute>} />
          <Route path="/dashboard/available" element={<PrivateRoute><DashboardLayout><DonorDashboard /></DashboardLayout></PrivateRoute>} />
          <Route path="/dashboard/accepted" element={<PrivateRoute><DashboardLayout><DonorDashboard /></DashboardLayout></PrivateRoute>} />
          <Route path="/dashboard/history" element={<PrivateRoute><DashboardLayout><DonorDashboard /></DashboardLayout></PrivateRoute>} />
          <Route path="/dashboard/profile" element={<PrivateRoute><DashboardLayout><DonorDashboard /></DashboardLayout></PrivateRoute>} />
          <Route path="/dashboard/stats" element={<PrivateRoute><DashboardLayout><UserStatsDashboard /></DashboardLayout></PrivateRoute>} />

          {/* Requester Dashboard Routes */}
          <Route path="/requester-dashboard" element={<PrivateRoute><DashboardLayout><RequesterDashboard /></DashboardLayout></PrivateRoute>} />
          <Route path="/requester-dashboard/create" element={<PrivateRoute><DashboardLayout><RequesterDashboard /></DashboardLayout></PrivateRoute>} />
          <Route path="/requester-dashboard/active" element={<PrivateRoute><DashboardLayout><RequesterDashboard /></DashboardLayout></PrivateRoute>} />
          <Route path="/requester-dashboard/history" element={<PrivateRoute><DashboardLayout><RequesterDashboard /></DashboardLayout></PrivateRoute>} />
          <Route path="/requester-dashboard/profile" element={<PrivateRoute><DashboardLayout><RequesterDashboard /></DashboardLayout></PrivateRoute>} />

          {/* User Profile Route */}
          <Route path="/user-profile" element={<PrivateRoute><UserProfilePage /></PrivateRoute>} />

          {/* Donation Verification Route */}
          <Route path="/dashboard/requester/verify-donation/:requestId/:donorId" element={<PrivateRoute><VerifyDonation /></PrivateRoute>} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}